import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    line: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '40px',
      padding: '10px',
      borderRadius: '10px',
      backgroundColor: palette.background.underBox,
      boxSizing: 'border-box',
      userSelect: 'none'
    },
    textImageContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    selectedLine: {
      outline: '3px solid blue'
    },
    image: {
      height: '20px'
    },
    warningCheques: {
      color: palette.text.primary
    },
    warning: {
      borderTop: '2px solid #F3F4F6',
      paddingTop: '10px'
    },
    warningLink: {
      fontWeight: 'bold',
      color: palette.text.primary
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
